<template>
  <div>
    <v-simple-table fixed-header height="300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">No. Order</th>
            <th class="text-left">Nomor Resi</th>
            <th class="text-left">Data Penerima</th>

            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr @click="detail(item)" v-for="item in laporan" :key="item.name">
            <td>{{ item.No_Order }}</td>
            <td>{{ item.No_Resi }} - {{item.Kurir}}</td>
            <td>{{ item.Penerima }} ({{item.PenerimaHp}})</td>

            <td>{{ item.Status}}</td>
            <td>
              <v-chip v-if="item.status == 'PROSES'" color="red">{{item.status}}</v-chip>
              <v-chip v-if="item.status == 'DIKIRIM'" color="blue">{{item.status}}</v-chip>
              <v-chip v-if="item.status == 'SELESAI'" color="yellow">{{item.status}}</v-chip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="invoice" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{inv_detail.no_order}}</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="4">
              <div>
                <b>Nama</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Jumlah</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Alamat</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Provinsi</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Kota/Kabupaten</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Kecamatan</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Kodepos</b>
              </div>
              <v-divider></v-divider>
              <div>
                <b>Kurir</b>
              </div>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="7">
              <div>{{inv_detail.nama_item}}</div>
              <v-divider></v-divider>
              <div>{{inv_detail.qty}} Item</div>
              <v-divider></v-divider>
              <div>Selomas Barat I/872</div>
              <v-divider></v-divider>
              <div>Jawa Tengah</div>
              <v-divider></v-divider>
              <div>Semarang</div>
              <v-divider></v-divider>
              <div>Semarang Utara</div>
              <v-divider></v-divider>
              <div>50177</div>
              <v-divider></v-divider>
              <div>JNE-YES</div>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="inv_detail.status == 'PROSES'"
            color="primary"
            text
            @click="kirim(inv_detail)"
          >Kirim</v-btn>
          <v-btn color="primary" text @click="invoice = false">Kembali</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inpResi" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Input Nomor Resi</v-card-title>
        <div class="pa-4">
          <v-text-field label="Nomor Resi" v-model="resi" placeholder="Resi harus valid"></v-text-field>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="inpResi = false">kirim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      invoice: false,
      inv_detail: "",
      inpResi: false,
      resi: null,
      userid: localStorage.getItem("user_id"),
      laporan: []
    };
  },
  mounted() {
    this.getPenjualan();
  },
  methods: {
    detail(data) {
      this.inv_detail = data;

      this.invoice = true;
    },
    getPenjualan() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/pengirim/" +
          this.userid +
          "/selesai"
      )
        .then(response => response.json())
        .then(data => {
          this.laporan = data;
        });
    }
  }
};
</script>
